// extracted by mini-css-extract-plugin
export var body = "reviews-module--body--5952b";
export var desk_top = "reviews-module--desk_top--f4dbb";
export var empty = "reviews-module--empty--6354e";
export var filled = "reviews-module--filled--530c0";
export var half = "reviews-module--half--4bdc0";
export var head = "reviews-module--head--232e4";
export var label = "reviews-module--label--d4126";
export var left = "reviews-module--left--77be4";
export var loading = "reviews-module--loading--51b2b";
export var mobi_top = "reviews-module--mobi_top--8520d";
export var over_cnt = "reviews-module--over_cnt--c4ac3";
export var over_rating = "reviews-module--over_rating--4726e";
export var over_total = "reviews-module--over_total--14ef5";
export var pagin_btn = "reviews-module--pagin_btn--0a91d";
export var paginate = "reviews-module--paginate--af8f4";
export var pl_name = "reviews-module--pl_name--0f631";
export var product = "reviews-module--product--308ab";
export var rating = "reviews-module--rating--d4857";
export var review = "reviews-module--review--79775";
export var reviewer = "reviews-module--reviewer--c52f6";
export var reviews = "reviews-module--reviews--be1cf";
export var right = "reviews-module--right--b6784";
export var sort_btn = "reviews-module--sort_btn--3c64d";
export var sort_item = "reviews-module--sort_item--bc10a";
export var sort_list = "reviews-module--sort_list--3ea5f";
export var sort_wr = "reviews-module--sort_wr--0ac62";
export var star = "reviews-module--star--966c1";
export var title = "reviews-module--title--e405f";
export var top_btn = "reviews-module--top_btn--fb078";
export var wrap = "reviews-module--wrap--8813c";